import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControlRemote } from '../../../../../shared/form/element/form-control-remote';

@Injectable()
export class CampaignForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      customer: new FormControlRemote('id'),
      name: [ '', Validators.required ],
      domain: [ '', Validators.required ],
      status: [ '', Validators.required ]
    });
  }
}
